"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CallPopupReducer = void 0;
var CallPopupAction_1 = require("../actions/CallPopupAction");
var CallPopupState_1 = require("../states/CallPopupState");
var typesafe_actions_1 = require("typesafe-actions");
exports.CallPopupReducer = function (state, action) {
    if (state === void 0) { state = CallPopupState_1.defaultCallPopupState; }
    switch (action.type) {
        case typesafe_actions_1.getType(CallPopupAction_1.default.onSetActive): {
            return __assign(__assign({}, state), { active: action.payload });
        }
        case typesafe_actions_1.getType(CallPopupAction_1.default.onCallPopupCloseClick): {
            return __assign(__assign({}, state), { active: false });
        }
        default:
            return __assign(__assign({}, state), { active: false });
    }
};
